// Uniform status badge across the whole app.
const STYLES = {
  positive: "bg-teal-50 text-teal-700 ring-1 ring-inset ring-teal-600/20",
  pending: "bg-white text-neutral-700 ring-1 ring-inset ring-neutral-300",
  neutral: "bg-neutral-100 text-neutral-400 ring-1 ring-inset ring-neutral-200",
};

const MAP = {
  ACTIVE: "positive",
  CONFIRMED: "positive",
  COMPLETED: "positive",
  DRAFT: "pending",
  PROPOSED: "pending",
  REJECTED: "neutral",
  ARCHIVED: "neutral",
  SUPERSEDED: "neutral",
};

const LABELS = {
  ACTIVE: "In corso",
  COMPLETED: "Completato",
  ARCHIVED: "Archiviato",
  DRAFT: "Bozza",
  PROPOSED: "Da confermare",
  CONFIRMED: "Confermato",
  REJECTED: "Rifiutato",
  CANCELLED: "Annullato",
  SUPERSEDED: "Sostituito",
};

export const StatusBadge = ({ status }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold tracking-wide ${
      STYLES[MAP[status]] || STYLES.neutral
    }`}
  >
    {LABELS[status] || status}
  </span>
);
